<template>
<div class="cta-link" @mouseover="onMouseOver" @mouseleave="onMouseLeave">
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="cta-goo" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" color-interpolation-filters="sRGB"  />
        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -6"  result="cta-goo" />
        <feBlend in="SourceGraphic" in2="cta-goo" />
      </filter>
    </defs>
  </svg>
  <router-link :to="to" class="cta-wrapper">
    <div ref="blobs" class="cta-blobs">
      <div ref="bg" class="blob-bg" :style="{ backgroundColor: bgColor }"></div>
      <div ref="blob1" class="blob blob1" :style="{ backgroundColor: bgColor }"></div>
      <div ref="blob2" class="blob blob2" :style="{ backgroundColor: bgColor }"></div>
      <div ref="blob3" class="blob blob3" :style="{ backgroundColor: bgColor }"></div>
    </div>
    <div class="cta-content">
      <span ref="text" :style="{ color: textColor }" class="text">
        <slot></slot>
      </span>
      <span ref="emoji" class="emoji">
        {{ emoji }}
      </span>
    </div>
  </router-link>
  </div>
</template>

<script>
import { TimelineMax } from 'gsap/TweenMax'

export default {
  props: {
    to: [Object, String],
    bgColor: {
      type: String,
      default: '#000'
    },
    textColor: {
      type: String,
      default: '#FFFFFF'
    },
    emoji: {
      type: String,
      default: '👉'
    },
    hoverColor: {
      type: String,
      default: '#FF2F89'
    }
  },
  data() {
    return {
      tl: null,
      hoverState: false
    }
  },
  methods: {
    initAnimation() {
      const ease = Cubic.easeInOut;
      const speed = 0.2;
      this.tl = new TimelineMax({paused: true});
      // this.tl.set(this.$refs.blob3, { x: "-50%" }, 0)
      this.tl.set(this.$refs.blobs, {filter: "none"})
      this.tl.set(this.$refs.blobs, {filter: "url('#cta-goo')"})
      this.tl.set(this.$refs.blobs.children, { backgroundColor: this.bgColor, ease }, 0);
      this.tl.to(this.$refs.blobs.children, 0.2, { backgroundColor: this.hoverColor, ease }, 0);
      this.tl.to(this.$refs.bg, speed, { scale: 0, ease, transformOrigin: "50% 50%"}, 0)
      this.tl.to(this.$refs.blob3, speed, { scale: 1.7, ease, transformOrigin: "50% 50%" }, 0)
      this.tl.to(this.$refs.text, speed, { scale: 0, ease, transformOrigin: "50% 50%"}, 0)
      this.tl.to(this.$refs.emoji, speed, { scale: 1, ease, transformOrigin: "50% 50%"}, 0)
      this.tl.add("blobs")
      this.tl.set([this.$refs.blob1, this.$refs.blob2], { scale: 1.7 }, "blobs");
      this.tl.to(this.$refs.blob1, 0.6, { x: "-120%", y: "-40%", scale: 0 }, "blobs")
      this.tl.to(this.$refs.blob2, 0.4, { x: "120%", y: "40%", scale: 0 },"blobs")
    },
    onMouseOver() {
      if(!this.hoverState && window.innerWidth >= 768) {
        this.hoverState = true;
        this.tl.restart();
      }
    },
    onMouseLeave() {
      if(this.hoverState && window.innerWidth >= 768) {
        this.hoverState = false;
        this.tl.reverse();
      }
    }
  },
  mounted() {
    this.initAnimation();
  }
}
</script>


<style lang="scss" scoped>
  
  .cta-link {
    position: relative;
    font-size: 1rem;
    
    @media (min-width: 768px) {
      font-size: 1.2rem;
    }
    @media (min-width: 768px) {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 82px;
    }
    svg {
      width: 0;
      height: 0;
    }
  }
  .cta-wrapper {
    position: relative;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    color: white;
    text-decoration: none;
    font-weight: bold;

    @media (min-width: 640px) {
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
    }
    
    .cta-content {
      position: relative;

      .text {
        display: inline-block;
      }

      .emoji {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2em;
        transform: scale(0);
      }
    }

    .cta-blobs {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .blob-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 2rem;
    }

    .blob {
      display: none;
    }

    @media (min-width: 768px) {
      .cta-blobs {
        // filter:url('#cta-goo');
        // backface-visibility: visible;
        
        // & > * {
        //   backface-visibility: visible;
        // }
      }

      .blob {
        display: block;
        position: absolute;
        border-radius: 50%;
        width: 48px;
        height: 48px;
        top: 0;
        left: 50%;
        margin-left: -24px;
        
      }
      

    }
  }
</style>
